import { Injectable } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class IconRegistryService {
  constructor(
    private readonly iconRegistry: MatIconRegistry,
    private readonly sanitizer: DomSanitizer
  ) { }

  icons = [
    { name: 'addCircle', url: this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/add_circle.svg') },
    { name: 'arrowDown', url: this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/arrow_down.svg') },
    { name: 'arrowUp', url: this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/arrow_up.svg') },
    { name: 'backArrow', url: this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/back.svg') },
    { name: 'calendar', url: this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/calendar.svg') },
    { name: 'check', url: this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/check.svg') },
    { name: 'close', url: this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/close.svg') },
    { name: 'documents', url: this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/documentsIcon.svg') },
    { name: 'download', url: this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/downloadIcon.svg') },
    { name: 'edit', url: this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/edit.svg') },
    { name: 'ellipsis-v', url: this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ellipsis-v.svg') },
    { name: 'help-outline', url: this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/helpOutline.svg') },
    { name: 'information', url:this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/information.svg') },
    { name: 'reset', url: this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/reset.svg') },
    { name: 'shield-star', url: this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/shield_star.svg') },
    { name: 'signature', url: this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/signingIcon.svg') },
    { name: 'sync', url: this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/sync.svg') },
    { name: 'thumpUp-alt', url: this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/thumb_up_alt.svg') },
    { name: 'trash', url: this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/trash.svg') },
    { name: 'video', url: this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/videoIcon.svg') },
  ];

  registerIcons() {
    this.icons.forEach(icon => {
      this.iconRegistry.addSvgIcon(icon.name, icon.url);
    });
  }
}
